import { reactive } from 'vue';

// The sidebar's question — does she hold "Daten importieren" anywhere? — is asked once
// per user and tenant for the session, in memory only (nothing in localStorage). Kept in
// a module of its own, free of any API client, so the auth and tenants stores can drop
// the answers on sign-out and refresh without importing the module APIs (issue 1063).
// Reactive, so the sidebar shows the entry the moment the probe returns. Only a settled
// yes/no is kept: when no module answered at all the next ask tries again.
const anyAnswers = reactive(new Map<string, boolean>());
const inflight = new Map<string, Promise<boolean>>();
let generation = 0;

export const anyAccessKey = (userId: string, tenantSlug: string) => `${userId}|${tenantSlug}`;
export const anyAccessAnswers = anyAnswers;
export const anyAccessInflight = inflight;
export const anyAccessGeneration = () => generation;

/** The answer this session already holds, if any. */
export function cachedAnyImportAccess(userId: string | null | undefined, tenantSlug: string | null | undefined): boolean | undefined {
  if (!userId || !tenantSlug) return undefined;
  return anyAnswers.get(anyAccessKey(userId, tenantSlug));
}

/**
 * Drop every kept answer: on sign-out, and whenever the tenants store asks the
 * workspace to re-read itself — a role given or taken in the meantime must count.
 */
export function forgetDataImportAccess(): void {
  generation += 1;
  anyAnswers.clear();
  inflight.clear();
}
